import React, { Component } from 'react';

// Bảng emoji tĩnh theo nhóm, không cần thư viện ngoài
const EMOJI_GROUPS = [
    {
        name: "Mặt cười",
        icon: "😀",
        emojis: [
            "😀", "😃", "😄", "😁", "😆", "😅", "🤣", "😂", "🙂", "🙃",
            "😉", "😊", "😇", "🥰", "😍", "🤩", "😘", "😗", "😚", "😙",
            "😋", "😛", "😜", "🤪", "😝", "🤗", "🤭", "🤔", "🤐", "😐",
            "😑", "😶", "😏", "😒", "🙄", "😬", "😌", "😔", "😪", "😴",
            "😷", "🤒", "🤕", "🥴", "😵", "🤯", "🥳", "😎", "🤓", "🧐",
            "😕", "😟", "🙁", "😮", "😯", "😲", "😳", "🥺", "😦", "😧",
            "😨", "😰", "😥", "😢", "😭", "😱", "😖", "😣", "😞", "😓",
            "😩", "😫", "😤", "😡", "😠", "🤬", "😈", "💀", "🤡", "👻"
        ]
    },
    {
        name: "Cử chỉ",
        icon: "👍",
        emojis: [
            "👍", "👎", "👌", "✌️", "🤞", "🤟", "🤘", "🤙", "👈", "👉",
            "👆", "👇", "☝️", "✋", "🤚", "🖐️", "🖖", "👋", "🤝", "🙏",
            "💪", "🦾", "👏", "🙌", "👐", "🤲", "✍️", "💅", "👀", "👁️",
            "👶", "🧒", "👦", "👧", "🧑", "👨", "👩", "🧓", "👴", "👵"
        ]
    },
    {
        name: "Trái tim",
        icon: "❤️",
        emojis: [
            "❤️", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍", "🤎", "💔",
            "❣️", "💕", "💞", "💓", "💗", "💖", "💘", "💝", "💟", "💌",
            "💋", "💯", "💢", "💥", "💫", "💦", "💨", "🔥", "✨", "⭐"
        ]
    },
    {
        name: "Khác",
        icon: "🎁",
        emojis: [
            "🎵", "🎶", "🎤", "🎧", "🎸", "🥁", "🎹", "🎬", "📱", "💻",
            "🎁", "🎉", "🎊", "🎈", "🏆", "🥇", "🎯", "🎮", "☕", "🍔",
            "🍕", "🍰", "🍺", "🌹", "🌸", "🌞", "🌙", "⚡", "✅", "❌",
            "⚠️", "❓", "❗", "💰", "💎", "🕐", "📌", "📢", "🔔", "🔕"
        ]
    }
];

export default class EmojiPicker extends Component {
    constructor(props) {
        super(props);
        this.state = { activeGroup: 0 };
        this.containerRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    // Bấm ra ngoài thì đóng bảng emoji
    handleClickOutside(event) {
        const { onClose } = this.props;
        if (event.target.closest && event.target.closest('.emoji-toggle-btn')) return;
        if (this.containerRef.current && !this.containerRef.current.contains(event.target)) {
            if (onClose) onClose();
        }
    }

    render() {
        const { onSelect } = this.props;
        const { activeGroup } = this.state;
        const group = EMOJI_GROUPS[activeGroup];

        return (
            <div className="emoji-picker" ref={this.containerRef} role="dialog" aria-label="Chọn biểu tượng cảm xúc">
                <div className="emoji-picker-header">
                    <div>
                        <strong>Biểu tượng cảm xúc</strong>
                        <span>{group.name}</span>
                    </div>
                    <button type="button" title="Đóng" aria-label="Đóng" onClick={this.props.onClose}>
                        <i className="fa fa-times" aria-hidden="true" />
                    </button>
                </div>
                <div className="emoji-picker-tabs" role="tablist">
                    {EMOJI_GROUPS.map((g, index) => (
                        <button
                            key={g.name}
                            type="button"
                            title={g.name}
                            aria-label={g.name}
                            role="tab"
                            aria-selected={index === activeGroup}
                            className={`emoji-tab ${index === activeGroup ? "active" : ""}`}
                            onClick={() => this.setState({ activeGroup: index })}
                        >
                            {g.icon}
                        </button>
                    ))}
                </div>
                <div className="emoji-picker-body">
                    {group.emojis.map((emoji, index) => (
                        <button
                            key={`${emoji}-${index}`}
                            type="button"
                            className="emoji-item"
                            title={`Chèn ${emoji}`}
                            aria-label={`Chèn ${emoji}`}
                            onClick={() => onSelect(emoji)}
                        >
                            {emoji}
                        </button>
                    ))}
                </div>
            </div>
        );
    }
}
